import Bugsnag, { type Event as BugsnagEvent } from '@bugsnag/js'

import { ensureError } from './ensureError'

const reportedErrors = new WeakSet<Error>()

/**
 * Reports an error at most once while preserving the same Error instance as it
 * propagates through API and UI catch boundaries.
 */
export function reportError(
  error: unknown,
  onEvent?: (event: BugsnagEvent) => void
): Error {
  const errorObject = ensureError(error)

  if (reportedErrors.has(errorObject)) {
    return errorObject
  }

  reportedErrors.add(errorObject)
  if (onEvent) {
    Bugsnag.notify(errorObject, onEvent)
  } else {
    Bugsnag.notify(errorObject)
  }

  return errorObject
}
